var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('de-layout-content',[_c('div',{staticClass:"pad-b20"},[_c('div',{staticClass:"bl_title"},[_vm._v("新增接入")]),_c('from-dom',{attrs:{"componentsType":"add"}})],1)])}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }